import { Routes, Route } from 'react-router-dom'
import {
  AuthorizePage,
  BillingAgreePage,
  CompleteProfilePage,
  ConsentPage,
  DeviceVerifyPage,
  ErrorPage,
  ForgotPasswordPage,
  LinkAccountPage,
  LoginPage,
  LogoutPage,
  MFAChallengePage,
  ResetPasswordPage,
  SilentCallbackPage,
  StepUpPage,
  VerifyEmailPage,
} from './pages'
import { PayPalCallbackPage } from './pages/PayPalCallbackPage'

function App() {
  return (
    <Routes>
      {/* Home redirects to login */}
      <Route path="/" element={<Home />} />

      {/* Auth pages */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/logout" element={<LogoutPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/complete-profile" element={<CompleteProfilePage />} />
      <Route path="/device-verify" element={<DeviceVerifyPage />} />
      <Route path="/link-account" element={<LinkAccountPage />} />
      <Route path="/mfa-challenge" element={<MFAChallengePage />} />

      {/* OAuth/OIDC routes */}
      <Route path="/authorize" element={<AuthorizePage />} />
      <Route path="/oauth/authorize" element={<AuthorizePage />} />
      <Route path="/consent" element={<ConsentPage />} />
      <Route path="/oauth/consent" element={<ConsentPage />} />
      <Route path="/silent-callback" element={<SilentCallbackPage />} />
      <Route path="/error" element={<ErrorPage />} />

      {/* Step-up verification - Phase 12 */}
      <Route path="/stepup/:challengeId" element={<StepUpPage />} />

      {/* Billing - Phase 15 */}
      <Route path="/billing/agree" element={<BillingAgreePage />} />
      <Route path="/billing/paypal/callback" element={<PayPalCallbackPage />} />
    </Routes>
  )
}

// Home page - redirects or shows welcome
function Home() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--bg-base)]">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-[var(--text-primary)]">u.software</h1>
        <p className="mt-2 text-[var(--text-secondary)]">Identity Provider</p>
        <div className="mt-6">
          <a
            href="/login"
            className="rounded-lg bg-primary-600 px-6 py-2 text-sm font-medium text-white hover:bg-primary-700"
          >
            Sign in
          </a>
        </div>
      </div>
    </div>
  )
}

export default App
